export const accounts = {
  primary: { light: "#00A676", dark: "#00A676" }
};
  